import { MdFullscreen } from "react-icons/md";
import useFetch from "../../../hooks/useFetch";
import request from "../../../utils/request";
import { Card, CardBody } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { socket } from "./socket";

const ServiceTokenShow = () => {
  const { data: settingsData } = useFetch(() => request.getAll("settings"));
  const settingData = settingsData[0];
  const [refresh, setRefresh] = useState(false);
  const isPlayingRef = useRef(false);

  const [mainScreenToken, setMainScreenToken] = useState(null);
  const [tokenListByCounter, setTokenListByCounter] = useState([]);

  // console.log("tokenData", tokenData);

  useEffect(() => {
    (async () => {
      try {
        const res = await request.getAll(
          "queue-management/service-list/token/current-token"
        );
        // console.log(res);
        if (res.status === "OK") {
          // setMainScreenToken(res.data?.latestCalledToken);
          setTokenListByCounter(res.data?.currentCounterToken);
          // playAudio(
          //   res.data.latestCalledToken?.token,
          //   res?.data?.latestCalledToken?.counter?.name,
          //   isPlayingRef,
          // );
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [refresh]);

  // main screen data fetch

  useEffect(() => {
    (async () => {
      try {
        const res = await request.getAll(
          "queue-management/service-list/token/main-screen"
        );
        console.log(res);
        if (res.status === "OK") {
          setMainScreenToken(res.data);
          // if (res?.data) {
          //   playAudio(res.data?.token, res?.data?.counter?.name, isPlayingRef);
          // }
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  const { data: staticContent } = useFetch(() =>
    request.getOne("static-content-groups", 8)
  );
  const staticContentText = staticContent?.static_contents
    ?.map((sta) => sta?.name)
    .join(" | ");

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      // Enter fullscreen
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        // Safari
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen();
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        // Safari
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }
  };

  const playAudio = (token, counter, isPlayingRef) => {
    if (isPlayingRef.current) {
      console.log("Audio is already playing. Skipping new playback.");
      return; // Skip if an audio is already playing
    }

    // Generate the TTS URL with token and counter dynamically
    const text = `Token Number ${token}, Counter ${counter}`;
    const encodedText = encodeURIComponent(text);
    const audioUrl = `https://translate.google.com/translate_tts?ie=UTF-8&client=tw-ob&tl=en&q=${encodedText}`;

    // Create a new audio instance with the generated URL
    const audio = new Audio(audioUrl);

    // Mark audio as playing
    isPlayingRef.current = true;

    audio
      .play()
      .then(() => {
        console.log("Audio is playing.");
        // When the audio finishes, mark it as not playing
        audio.onended = () => {
          isPlayingRef.current = false;
          console.log("Audio playback finished.");
        };
      })
      .catch((error) => {
        console.error("Error playing the audio:", error);
        isPlayingRef.current = false; // Reset in case of an error
      });
  };

  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    socket.on("updateTokens", (data) => {
      console.log("updateTokens", data);
      setRefresh((previous) => !previous);

      setMainScreenToken(data.currentToken);

      // playAudio(
      //   data.currentToken?.token,
      //   data.currentToken?.counter?.name,
      //   isPlayingRef
      // );
    });

    socket.on("onBreak", () => {
      setRefresh((previous) => !previous);
    });

    socket.on("recallToken", (data) => {
      // console.log("recallToken", data);
      if (data) {
        // playAudio(data.token, data.counter?.name, isPlayingRef);
        setMainScreenToken(data);
        setTokenListByCounter((prev) => {
          const exists = prev.some((item) => item.counterId === data.counterId);
          if (exists) {
            // Replace the existing item
            return prev.map((item) =>
              item.counterId === data.counterId ? data : item
            );
          } else {
            // Insert the new item
            return [...prev, data];
          }
        });
      }
    });

    socket.on("newToken", (data) => {
      if (data) {
        setMainScreenToken(data);
        setTokenListByCounter((prev) => {
          const exists = prev.some((item) => item.counterId === data.counterId);
          if (exists) {
            // Replace the existing item
            return prev.map((item) =>
              item.counterId === data.counterId ? data : item
            );
          } else {
            // Insert the new item
            return [...prev, data];
          }
        });
      }
    });

    socket.on("prevTokenCalling", (data) => {
      console.log("prevTokenCalling", data);
      setMainScreenToken(data);
    });

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("updateTokens");
      socket.off("onBreak");
      socket.off("recallToken");
      socket.off("newToken");
      socket.off("prevTokenCalling");
    };
  }, [setRefresh]);

  return (
    <div className="vh-100">
      <div className="d-flex justify-content-between  text-white p-4 bg-cyan">
        <div className="fs-3">Clincx Token</div>
        <div className="d-flex gap-3 align-items-center">
          <p className="m-0 p-0 fs-3">{settingData?.website_name}</p>
          <div className="cursor-pointer" onClick={toggleFullscreen}>
            <MdFullscreen size={40} />
          </div>
        </div>
      </div>

      <div className=" mx-5 d-flex gap-2 h-100 mt-5">
        <div style={{ width: "70%" }}>
          <Card style={{ height: "70%" }}>
            <CardBody className="text-center">
              {mainScreenToken ? (
                <>
                  <p className="mt-5 font-size-5" style={{ fontSize: "70px" }}>
                    Token Number
                  </p>
                  <h2 className="font-size-8 text-danger">
                    {mainScreenToken?.token}
                  </h2>
                  <h3 className="font-size-5">Please Proceed to</h3>
                  <h2 className="font-size-5 text-danger">
                    Counter: {mainScreenToken?.counter?.name}
                  </h2>
                </>
              ) : (
                <>
                  <p className="mt-5 font-size-5">No Token Available</p>
                </>
              )}
            </CardBody>
          </Card>
        </div>

        <div style={{ width: "30%" }}>
          {tokenListByCounter?.map((token) => (
            <Card key={token.id} className="p-0 m-0 mb-1">
              <CardBody className="text-center p-0 pt-2 m-0">
                <h3 className="fs-4">Token Number</h3>
                <h2 className="fs-1 text-danger">{token.token}</h2>
                <h3 className="fs-2">
                  Counter: {token?.counter?.name}{" "}
                  {token?.counter?.isOnBreak && (
                    <span className="fs-2"> (On Break)</span>
                  )}{" "}
                </h3>
              </CardBody>
            </Card>
          ))}
        </div>
      </div>
      {staticContentText && (
        <div className="position-absolute  w-100" style={{ bottom: 100 }}>
          <div className="scrolling-container">
            <div className="scrolling-text  fs-1">{staticContentText}</div>
          </div>
        </div>
      )}

      <div className="text-center text-white p-4 bg-cyan position-absolute bottom-0 w-100">
        Powered By Clincx Medical Solution
      </div>
    </div>
  );
};
export default ServiceTokenShow;
